import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getApiClient, initializeApiClient } from "../../../../../Services/apiService";


export const GetOneJordanianGovernoratesProjectActivitiesData =
  createAsyncThunk(
    "OneJordanianGovernoratesProjectActivitiesData/OneGetJordanianGovernoratesProjectActivitiesData",
    async (
      tG_JordanianGovernoratesProjectActivitiesId,
      { rejectWithValue }
    ) => {
      try {
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post(
          "api/TG_JordanianGovernoratesProjectActivities/GetTG_JordanianGovernoratesProjectActivitiesData",
          {
            tG_JordanianGovernoratesProjectActivitiesId:
              tG_JordanianGovernoratesProjectActivitiesId,
          }
        );

        // Extract data from the response object
        const data = response.data.result; // Assuming response has a "data" field
        //console.log(data, "data");

        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

  export const ValidateOneJordanianGovernoratesProjectActivitiesData =
    createAsyncThunk(
      "OneJordanianGovernoratesProjectActivitiesData/ValidateOneJordanianGovernoratesProjectActivitiesData",
      async (
        JordanianGovernoratesProjectActivitiesData,
        { rejectWithValue }
      ) => {
        try {
          await initializeApiClient();
          const apiClient = await getApiClient();
          const response = await apiClient.post(
            "api/TG_JordanianGovernoratesProjectActivities/ValidateJordanianGovernoratesProjectActivities",
            {
              tG_JordanianGovernoratesNameId:
                JordanianGovernoratesProjectActivitiesData.tG_JordanianGovernoratesNameId,
            }
          );

          // Extract data from the response object
          const data = response.data.result; // Assuming response has a "data" field
          if (response.data.success === true) {
            const arrayValidate = response.data.result.map((ele, ind) => {
              return ele.code;
            });
            return arrayValidate; // Return the extracted data
          }
          return data; // Return the extracted data
        } catch (error) {
          return rejectWithValue(error.message);
        }
      }
    );


const OneJordanianGovernoratesProjectActivitiesData = createSlice({
  name: "OneJordanianGovernoratesProjectActivitiesData",
  initialState: {
    OneJordanianGovernoratesProjectActivitiesData: {},
    loadingOneJordanianGovernoratesProjectActivitiesData: false,
    errorOneJordanianGovernoratesProjectActivitiesData: null,

    OneValidateOneJordanianGovernoratesProjectActivitiesData: [],
    loadingValidateOneJordanianGovernoratesProjectActivitiesData: false,
    errorValidateOneJordanianGovernoratesProjectActivitiesData: null,
  },
  reducers: {
    restValidationJorList :(state,action)=>{
      state.OneValidateOneJordanianGovernoratesProjectActivitiesData = [];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        GetOneJordanianGovernoratesProjectActivitiesData.pending,
        (state, action) => {
          state.loadingOneJordanianGovernoratesProjectActivitiesData = true;
          state.OneJordanianGovernoratesProjectActivitiesData = action.payload;
          state.errorOneJordanianGovernoratesProjectActivitiesData = null;
        }
      )
      .addCase(
        GetOneJordanianGovernoratesProjectActivitiesData.fulfilled,
        (state, action) => {
          state.loadingOneJordanianGovernoratesProjectActivitiesData = false;
          state.OneJordanianGovernoratesProjectActivitiesData = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetOneJordanianGovernoratesProjectActivitiesData.rejected,
        (state, action) => {
          state.loadingOneJordanianGovernoratesProjectActivitiesData = false;
          state.errorOneJordanianGovernoratesProjectActivitiesData =
            action.payload;
        }
      )

      .addCase(
        ValidateOneJordanianGovernoratesProjectActivitiesData.pending,
        (state, action) => {
          state.loadingValidateOneJordanianGovernoratesProjectActivitiesData = true;
          state.OneValidateOneJordanianGovernoratesProjectActivitiesData =
            action.payload;
          state.errorValidateOneJordanianGovernoratesProjectActivitiesData =
            null;
        }
      )
      .addCase(
        ValidateOneJordanianGovernoratesProjectActivitiesData.fulfilled,
        (state, action) => {
          state.loadingValidateOneJordanianGovernoratesProjectActivitiesData = false;
          state.OneValidateOneJordanianGovernoratesProjectActivitiesData =
            action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        ValidateOneJordanianGovernoratesProjectActivitiesData.rejected,
        (state, action) => {
          state.loadingValidateOneJordanianGovernoratesProjectActivitiesData = false;
          state.errorValidateOneJordanianGovernoratesProjectActivitiesData =
            action.payload;
        }
      );



  },
});
export const { restValidationJorList } = OneJordanianGovernoratesProjectActivitiesData.actions;
export default OneJordanianGovernoratesProjectActivitiesData.reducer;
